module.exports = __webpack_public_path__ + "img/anvil_splash1.0e0d8701.png";